import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { IOrder } from '@cakeiteasy/web-utils';
import { OrdersApiService } from '../services/orders-api.service';
import { IOrderStatus } from '../models/i-order-models';

@Injectable()
export class OrdersManagerService {

  constructor(private _ordersApi: OrdersApiService) {
  }

  public order$ = new BehaviorSubject<IOrder>(null);
  public orderStatus$ = new BehaviorSubject<IOrderStatus>(null);

  public fetchOrder(sid: string): Promise<IOrder | null> {
    return this._ordersApi.getOrderBySid(sid)
      .then((order) => {
        this.order$.next(order);
        return order;
      })
      .catch(() => {
        this.order$.next(null);
        return null;
      });
  }

  public fetchOrderStatus(sid: string): Promise<IOrderStatus | null> {
    return firstValueFrom(this._ordersApi.getOrderStatusBySid(sid))
      .then((orderStatus) => {
        this.orderStatus$.next(orderStatus);
        return orderStatus;
      })
      .catch(() => {
        this.orderStatus$.next(null);
        return null;
      });
  }
}
